import * as React from "react";
import { forwardRef } from "react";
const SvgUnderline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 8V15C11 16.3261 11.5268 17.5979 12.4645 18.5355C13.4021 19.4732 14.6739 20 16 20C17.3261 20 18.5979 19.4732 19.5355 18.5355C20.4732 17.5979 21 16.3261 21 15V8M11 24H21", stroke: "#5A6367", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
